<div class="container-fluid p-0">
  <div class="row">
    <div class="col-12">
      <div class="d-flex justify-content-center align-items-center">
        <header class="header">
          <img class="header-logo" src="assets/images/logo/logo.svg" alt="" />
        </header>
      </div>
      <div class="section-auth-container login-card">
        <div>
          <div class="login-main">
            <div class="d-flex flex-column gap-2">
              <span class="fs-3 fw-medium">{{ "forms.create_new_password" | translate }}</span>
              <span class="fs-6">{{ "forms.create_new_password_description" | translate }}</span>
              <form class="theme-form w-100" ngNativeValidate [formGroup]="newPasswordForm">
                <div class="form-group">
                  <label class="col-form-label">{{ "forms.new_password" | translate }}</label>
                  <div class="form-input position-relative">
                    <input data-test="password" class="form-control" type="password" name="login[password]" [type]="show ? 'text' : 'password'" placeholder="*********" formControlName="newPassword" />
                    <div class="show-hide">
                      <span (click)="show = !show" [class.show]="show">
                        <i class="fa fa-eye" *ngIf="!show"></i>
                        <i class="fa fa-eye-slash" *ngIf="show"></i>
                      </span>
                    </div>
                    @if (newPasswordForm.controls['newPassword'].touched && newPasswordForm.controls['newPassword'].errors?.['required']) {
                    <div class="text text-danger mt-1">
                      {{ "forms.error_password_required" | translate }}
                    </div>
                    }
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-form-label">{{ "forms.repeat_password" | translate }}</label>
                  <div class="form-input position-relative">
                    <input data-test="password-repeat" class="form-control" type="password" name="login[password]" [type]="showRepeat ? 'text' : 'password'" placeholder="*********" formControlName="repeatPassword" />
                    <div class="show-hide">
                      <span (click)="showRepeat = !showRepeat" [class.show]="showRepeat">
                        <i class="fa fa-eye" *ngIf="!showRepeat"></i>
                        <i class="fa fa-eye-slash" *ngIf="showRepeat"></i>
                      </span>
                    </div>
                    @if (newPasswordForm.controls['repeatPassword'].touched && newPasswordForm.controls['repeatPassword'].errors?.['required']) {
                    <div class="text text-danger mt-1">
                      {{ "forms.error_password_required" | translate }}
                    </div>
                    } @if (newPasswordForm.errors?.['notSame'] && newPasswordForm.controls['repeatPassword'].touched) {
                    <div class="text text-danger mt-1">
                      {{ "forms.error_password_not_match" | translate }}
                    </div>
                    }
                  </div>
                </div>
                <div class="text-start mt-3 mb-3">
                  <button (click)="resetPassword()" class="btn btn-primary btn-block sweet-2" type="submit" [disabled]="newPasswordForm.invalid">
                    {{ "forms.update_password" | translate }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <footer class="footer footer-fix">
    <app-footer></app-footer>
  </footer>
</div>
